import { XML_DrawSmallSubchartArrowPPT } from "./XML_DrawSmallSubchartArrowPPT";
import { XML_DrawSmallSubchartArrowPDF } from "./XML_DrawSmallSubchartArrowPDF";
import { enumXMLType } from "../constants";

export function XML_DrawSmallSubchartArrow(
  x0,
  y0,
  x1,
  y1,
  x2,
  y2,
  drawElement,
  linkBookmark,
  layer,
  style
) {
  var docType = drawElement.GetDocType();

  if (docType == enumXMLType.PDF)
    XML_DrawSmallSubchartArrowPDF(x0, y0, x1, y1, x2, y2, drawElement, linkBookmark, layer, style);
  else
    XML_DrawSmallSubchartArrowPPT(x0, y0, x1, y1, x2, y2, drawElement, linkBookmark, layer, style);
}
